import React from "react";
import SideNav from "../components/SideNav/sideNav";
import Header from "../components/Header/hearder";
import { Wrapper } from "./layout.styles";
import UsersFeedback from "./UsersFeedback";

const FeedbackLayout = () => {
  return (
    <React.Fragment>
      <Header />
      <Wrapper>
        <SideNav />
        <div style={{margin: "70px 0px 0px 200px", width: "100%"}}>
        <UsersFeedback />
        </div>
      </Wrapper>
    </React.Fragment>
  );
};

export default FeedbackLayout;
